module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mobile_21723a.gif";